export function stepContactInformationBuilderUI(info) {
  return {
    ...info
  };
}
